<template>
  <div class="flex items-center justify-center p-6 bg-gray-100 text-gray-700 font-medium sm:text-lg lg:text-lg xl:text-xl 3xl:text-2xl">
    Browse resources by category
  </div>
  <div class="flex items-center justify-center p-6 bg-gray-100">
    <ul class="grid grid-cols-3 sm:gap-3 md:grid-cols-5 lg:grid-cols-7 gap-6">
      <li v-for="cat in categories" :key="cat.identifier">
        <button @click="appendCategory(cat.identifier)" class="w-full">
          <div class="text-center" data-bs-toggle="tooltip" data-bs-placement="top" :title="cat.description">
            <span class="flex justify-center gap-1 items-center">
              <i class="fa-4x text-gray-400" :class="cat.fa_class" />
              <p class="text-tiny lg:text-xs bg-blue-900 self-end pill-xs sm:pill-sm">{{ cat.count }}</p>
            </span>
            <div class="text-center text-sm font-light text-gray-500 uppercase">
              {{ cat.gn_description }}
            </div>
          </div>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { ResourceCategorySummaryService } from '@/services/resource-category-summary-service'
import { onBeforeMount, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
const service = new ResourceCategorySummaryService()

export default {
  name: 'ResourceCategorySummary',
  setup() {
    const store = useStore()
    const router = useRouter()
    const categories = ref([])

    onBeforeMount(async () => {
      categories.value = await service.Get()
    })

    function appendCategory(identifier) {
      store.dispatch('Resources/addCategory', identifier)
      router.push('/Resources')
    }

    return { categories, appendCategory }
  },
}
</script>

<style scoped>

</style>
